/**
 * Utility for resolving links against our router. Useful if the links are provided via the CMS and are required to be functional, relative links.
 */
export function useLinkValidator(acceptNonRelative: MaybeRefOrGetter<boolean>) {
  const router = useRouter()

  const { url: root } = useSiteConfig()

  return (url: string | undefined | null) => {
    if (!url) {
      return false
    }

    const relative = url.replace(root, '')

    if (relative.startsWith('/')) {
      try {
        const route = router.resolve(relative)
        if (route.name === 'fallback') {
          console.error('Unresolvable url', { url })
          return false
        }
      } catch (e) {
        console.error('Failed to resolve url', e, { url })
        return false
      }
    }

    return toValue(acceptNonRelative)
  }
}
